import type { ReactElement } from 'react';

import type { CellProps } from '../Cell';

import type { BaseDecorativeProps } from './types';

import { decorativeCellContainer, decorativeCellContent } from './styles.css';

export interface DecorativeCellProps {
  /**
   * The decorative element to render on the left side of the cell.
   */
  decorativeElement: ReactElement<BaseDecorativeProps>;

  /**
   * The cell to render on the right side.
   */
  children: ReactElement<CellProps>;
}

/**
 * A container component that renders a decorative element alongside a Cell.
 *
 * @example
 * ```tsx
 * <DecorativeCell decorativeElement={<DecorativeColor kind="error" />}>
 *   <Cell kind="title">
 *     <TextContent text="Error trace" />
 *   </Cell>
 * </DecorativeCell>
 * ```
 */
export const DecorativeCell = ({ decorativeElement, children }: DecorativeCellProps) => {
  return (
    <div className={decorativeCellContainer}>
      {decorativeElement}
      <div className={decorativeCellContent}>{children}</div>
    </div>
  );
};
